import { useEffect, useState } from "react";
import "./PopupForm.css";

export default function PopupForm() {
  const [show, setShow] = useState(false);

  // FORM STATE
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");

  useEffect(() => {
    setTimeout(() => setShow(true), 2000);

    const interval = setInterval(() => {
      setShow(true);
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  // SUBMIT FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ validation
    if (!name || !phone) {
      alert("Please fill required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
      const res = await fetch("https://goldcompanynearme.com/send.php", {
        method: "POST",
        body: formData,
      });

     const text = await res.text();
console.log("RAW RESPONSE:", text);

let data;
try {
  data = JSON.parse(text);
} catch (e) {
  alert("Server response error ❌");
  return;
}
      console.log("Server Response:", data); // ✅ debug

      if (data.status === "success") {
        alert("Message sent ✅");
        setShow(false);

        // clear form
        setName("");
        setEmail("");
        setPhone("");
        setPurity("");
        setGram("");
      } else {
        alert(data.msg || "Error ❌");
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      alert("Server Error ❌");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        <span className="close-btn" onClick={() => setShow(false)}>✕</span>

        <h2>Get in Touch with Trusted Gold Buyers.</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <select
            name="purity"
            value={purity}
            onChange={(e) => setPurity(e.target.value)}
          >
            <option value="">Gold Purity</option>
            <option>18K</option>
            <option>20K</option>
            <option>22K</option>
            <option>24K</option>
          </select>

          <input
            type="text"
            name="gram"
            placeholder="Gram"
            value={gram}
            onChange={(e) => setGram(e.target.value)}
          />

          <button type="submit">SUBMIT</button>

        </form>

      </div>
    </div>
  );
}